import { render, staticRenderFns } from "./CostMappingForm.vue?vue&type=template&id=8f6c2d9c&scoped=true&"
import script from "./CostMappingForm.vue?vue&type=script&lang=js&"
export * from "./CostMappingForm.vue?vue&type=script&lang=js&"
import style0 from "./CostMappingForm.vue?vue&type=style&index=0&id=8f6c2d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6c2d9c",
  null
  
)

export default component.exports